import '../../sass/Faq.scss'

const fnmap = {
    'toggle': 'toggle',
    'show': 'add',
    'hide': 'remove'
};
const collapse = (selector, cmd) => {
    const targets = Array.from(document.querySelectorAll(selector));
    targets.forEach(target => {
        target.classList[fnmap[cmd]]('Show');
        target.parentNode.parentNode.parentNode.classList[fnmap[cmd]]('Active');
    });
}

const onFaqClick = (ev) => {
    ev.preventDefault()

    const selector = ev.target.getAttribute('data-target')
    history.pushState(null, null, ev.target.href)
    ev.target.scrollIntoView({ block: "start" });

    collapse(selector, 'toggle')
};

let elements = []
const bootFaq = () => {
    elements.forEach(element => {
        element.removeEventListener('click', onFaqClick)
    })

    elements = []
    const triggers = Array.from(document.querySelectorAll('[data-toggle="faq"]'));

    const currentURL = new URL(window.location.href)
    if (currentURL.hash) {
        const hash = currentURL.hash.replaceAll('#', '')
        const element = document.getElementById(hash)
        if (element) {
            collapse(element.getAttribute('data-target'), 'show')
        }
    }

    triggers.forEach(element => {
        element.addEventListener('click', onFaqClick)
        elements.push(element)
    })
}

bootFaq()
